export enum EOperatorField {
  DEVICE_OPERATOR = 'deviceOperator',
  VISITOR_OPERATOR = 'visitorOperator',
  TRAFFIC_SOURCE_OPERATOR = 'trafficSourceOperator',
  VERSION_OPERATOR = 'versionOperator',
  PAGE_OPERATOR = 'pageOperator',
  CAMPAIGN_ITEM_OPERATOR = 'campaignItemOperator',
}
